import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import * as wjcCore from "@grapecity/wijmo";
import AiSearchPage from './views/AISearchPage/AiSearchPage';
import AdavnceSearch from './views/AdvanceSearch/AdvanceSearch';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const DocumentDetails = React.lazy(() => import('./views/details/DocumentDetails'));
const PdfViewGoogleAzure = React.lazy(() => import('./views/details/PdfViewGoogleAzure'));
const CompniesData = React.lazy(() => import('./views/compnies/CompniesData'));
const ProcessorsData = React.lazy(() => import('./views/processors/ProcessorsData'));
const CompanyUserData = React.lazy(() => import('./views/companyUser/CompanyUserData'));
const IssueHistoryData = React.lazy(() => import('./views/details/IssueHistoryData'))

// const TheHeaderNew = React.lazy(() => import('./containers/TheHeaderNew'));

const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataProvider: "",
      fireAppInitialized: {},
      dataLoaded: false,
      uid: ""
    }
  }

  componentDidMount = () => {
    wjcCore.setLicenseKey("ideportal.digitalglyde.com,926535591656245#B0yWXmpjIyNHZisnOiwmbBJye0ICRiwiI34zZGJ6SnNkQVVjNzJWQFh7RZpmVmd7NuZjN4h5drdkNId5LjdTRwQTNWhkV9IXWBNVYJhzRV5UYUZFMHZlQ9ImT7JzNGdGZWd5TJFleVZDUjhlU7IWRwdnW9hEWmBHSlp7RhlWaUNDcw9WZ5cVZTNDRmp4RvkkYa3SWhdjUnpFealXM0RGMvc7L8EFMJBVe8dWVzkXU62GZSdFS5cTOGVlR9oHa4MzLSVkZXZHSsNTMFNFOZBzNaJFWNVTV6dXZiBjUWtkQEtERpV5c5sGTr24MKd5cHdjWLllNMBDW6hzMPNGTLt6ZqF4YsVVQlRVcjp7SoNlV7MUSGd4S8Y5YqZzL7QTa6NmUGJGSjl7KONUaxQEWUNEbDhUe6MzM7EER8Z4K7oUYr3ET4dXdK9EMLFldONnWadjU92kWCZUYMJzdqhnS9JzaJRDaNxETCJUSURzTUBDS9FkI0IyUiwiICJURCFEOEZjI0ICSiwCNwITN8MTM9ATM0IicfJye&Qf35VfikEMyIlI0IyQiwiIu3Waz9WZ4hXRgACdlVGaThXZsZEIv5mapdlI0IiTisHL3JSNJ9UUiojIDJCLi86bpNnblRHeFBCIyV6dllmV4J7bwVmUg2Wbql6ViojIOJyes4nILdDOIJiOiMkIsIibvl6cuVGd8VEIgc7bSlGdsVXTg2Wbql6ViojIOJyes4nI4YkNEJiOiMkIsIibvl6cuVGd8VEIgAVQM3EIg2Wbql6ViojIOJyes4nIzMEMCJiOiMkIsISZy36Qg2Wbql6ViojIOJyes4nIVhzNBJiOiMkIsIibvl6cuVGd8VEIgQnchh6QsFWaj9WYulmRg2Wbql6ViojIOJyebpjIkJHUiwiI4IDO5ATMgITMzADNyAjMiojI4J7QiwiIt36YuUGZ9x6ZsFGdpdWak9CbhRncvBXZklmI0IyctRkIsISZklHbHBCbhRXanlGRiojIh94QiwiI5QjM6UjNxkTN5MTN6ITOiojIklkIs4XXbpjInxmZiwiIyYXMyAjMiojIyVmdizSWz")
    console.log("ideportal.digitalglyde.com App component mounted");

      // useEffect(() => {
  
      // let firebaseConfig = {
       //   apiKey: "AIzaSyA2lABjNHoBIT59FBdExUsCERc5RJw74ps",
       //   authDomain: "imagedataextract.firebaseapp.com",
       //   databaseURL: "https://imagedataextract.firebaseio.com",
      //   projectId: "imagedataextract",
       //   storageBucket: "imagedataextract.appspot.com",
       //   messagingSenderId: "685805190840",
       //   appId: "1:685805190840:web:86b3c58797f8dcd5e57e4d",
      //   measurementId: "G-2T0WHRW487"
       // }
  
  
       // let fireApp = firebase.initializeApp(firebaseConfig);
  
      // this.setState({ fireAppInitialized: fireApp })
       // setTimeout(() => {
      //   let uid = null
       //   firebase.auth().onAuthStateChanged(async (user) => {
       //     console.log("this.firebaseConfig", user);
       //     if (user && user.uid) {
      //       uid = user.uid
       //       this.setState({ uid: uid })
       //     }
       //   })
       //   setTimeout(() => {
       //     this.setState({ dataLoaded: true })
       //   }, 2000);
       // }, 3000);
     }

  // componentDidMount = () => {

 
  //    wjcCore.setLicenseKey("ideportalwebapp.azurewebsites.net,926535591656245#B0cJ5LlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPnBHS6QjMrJ5YzwmU7hWU8QmSGJ6SWZzT8BDWUZEZ5IjQt3iQwVjZDJlRQZFbqx6MCZVW5QDatlWbM3yRUtme8AVYydXORRDcKhjV5FjcHNjNSJTQRhFV7VUaI96Z6dUMVJ6ayEjRRxUML56avEVZ4F7ZRBzNCdWdupndxRVYzpFWrVGO4kjWBdVdxk6ZEtGR8Fld0ZUNwVUbhlERCZ5LoVFVpRzQyRGbsFzbvN7TDhzRn3mdyhEdiZndDJkdLdnV4YlMEdESYpVZPpGdFBnTqZDc7F6UUFzVMBnUuFTYh9mZJRVaWRGdTN6YaBXY9dUY9Yzam5md4ZWePVkNlhka9VWONVlNn3UQPBDVFl4NHNmYMNkRu3CeLJGU5J7ZFN5RxhjWF9kYMhkWldTRvsmYVBHOTFUQ8xGMyNFTW9EZsB7UrQXdi56TwsGZ5QHZjZXa7okdWRGWiojITJCLigzQwMUNGljI0ICSiwiM4kDNyUDMykTM0IicfJye=#Qf35VfikEMyIlI0IyQiwiIu3Waz9WZ4hXRgACdlVGaThXZsZEIv5mapdlI0IiTisHL3JSNJ9UUiojIDJCLi86bpNnblRHeFBCIyV6dllmV4J7bwVmUg2Wbql6ViojIOJyes4nILdDOIJiOiMkIsIibvl6cuVGd8VEIgc7bSlGdsVXTg2Wbql6ViojIOJyes4nI4YkNEJiOiMkIsIibvl6cuVGd8VEIgAVQM3EIg2Wbql6ViojIOJyes4nIzMEMCJiOiMkIsISZy36Qg2Wbql6ViojIOJyes4nIVhzNBJiOiMkIsIibvl6cuVGd8VEIgQnchh6QsFWaj9WYulmRg2Wbql6ViojIOJyebpjIkJHUiwiI4UDM5kDMgETMyEDNyAjMiojI4J7QiwiI4VmbuMXZ4l6ciV6dlJXd0FmLwBXYiV6dsFGdy3GclRWaiojIz5GRiwiIlRWesdEIsFGdpdWaEJiOiEmTDJCLiUDNyYTN6ETO5UzM5YjM9IiOiQWSiwSfdtlOicGbmJCLiIjdxIDMyIiOxIIZ")

  //   // useEffect(() => {

  //   // let firebaseConfig = {
  //   //   apiKey: "AIzaSyA2lABjNHoBIT59FBdExUsCERc5RJw74ps",
  //   //   authDomain: "imagedataextract.firebaseapp.com",
  //   //   databaseURL: "https://imagedataextract.firebaseio.com",
  //   //   projectId: "imagedataextract",
  //   //   storageBucket: "imagedataextract.appspot.com",
  //   //   messagingSenderId: "685805190840",
  //   //   appId: "1:685805190840:web:86b3c58797f8dcd5e57e4d",
  //   //   measurementId: "G-2T0WHRW487"
  //   // }


  //   // let fireApp = firebase.initializeApp(firebaseConfig);

  //   // this.setState({ fireAppInitialized: fireApp })
  //   // setTimeout(() => {
  //   //   let uid = null
  //   //   firebase.auth().onAuthStateChanged(async (user) => {
  //   //     console.log("this.firebaseConfig", user);
  //   //     if (user && user.uid) {
  //   //       uid = user.uid
  //   //       this.setState({ uid: uid })
  //   //     }
  //   //   })
  //   //   setTimeout(() => {
  //   //     this.setState({ dataLoaded: true })
  //   //   }, 2000);
  //   // }, 3000);
  // }

  render() {
    return (
      <HashRouter>
        {/* {window.location.pathname !== "/" ? <TheHeaderNew /> : null} */}
        <React.Suspense fallback={loading}>
          <Switch>
          <Route path='/advancesearch' render={props => <AdavnceSearch {...props}/>}/>
          <Route path='/aisearchpage' render={props => <AiSearchPage {...props}/>}/>
            <Route exact path="/" name="Login" render={props => <Login {...props} />} />
            <Route exact path="/register" name="Register Page" render={props => <Register {...props} />} />
            <Route exact path="/404" name="Page 404" render={props => <Page404 {...props} />} />
            <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
            <Route path="/incoming_list" name="Dashboard" render={props => <TheLayout {...props} />} />
            <Route path="/document_list" name="Colors" render={props => <TheLayout {...props} />} />
            <Route path="/details" name="DocumentDetails" render={props => <TheLayout {...props} />} />
            <Route path="/detail/:id" name="PdfViewGoogleAzure" render={props => <TheLayout {...props} />} />
            <Route path="/compnies" name="CompniesData" render={props => <TheLayout {...props} />} />
            <Route path="/processors" name="ProcessorsData" render={props => <TheLayout {...props} />} />
            <Route path="/companyUser" name="CompanyUserData" render={props => <TheLayout {...props} />} />
            <Route path="/issueHistory" name="IssueHistoryData" render={props => <TheLayout {...props} />} />





            
            {/* <Route path="/" name="Home" render={props => <TheLayout {...props} />} /> */}
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
